import { forwardRef, createElement } from 'react';

function IconExpenses(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M18.25 2a1.75 1.75 0 011.744 1.606L20 3.75v16a.75.75 0 01-.177.484l-.074.076-1.813 1.613a.75.75 0 01-.908.068l-.089-.068-1.314-1.17-1.314 1.17a.75.75 0 01-.811.121l-.097-.053-.089-.068L12 20.753l-1.314 1.17a.75.75 0 01-.811.121l-.097-.053-.089-.068-1.314-1.17-1.314 1.17a.75.75 0 01-.811.121l-.097-.053-.089-.068-1.813-1.613a.75.75 0 01-.243-.454L4 19.75v-16a1.75 1.75 0 011.606-1.744L5.75 2h12.5zm0 1.5H5.75a.25.25 0 00-.243.193L5.5 3.75v15.662l1.063.946 1.313-1.168a.75.75 0 01.812-.122l.096.053.09.069 1.314 1.168 1.313-1.168a.75.75 0 01.812-.122l.096.053.09.069 1.314 1.168 1.313-1.168a.75.75 0 01.812-.122l.096.053.09.069 1.314 1.168 1.062-.945V3.75a.25.25 0 00-.13-.22l-.063-.023-.057-.007zm-2.5 9.5a.75.75 0 110 1.5h-7.5a.75.75 0 110-1.5h7.5zm-3-3.5a.75.75 0 110 1.5h-4.5a.75.75 0 110-1.5h4.5zm3-3.5a.75.75 0 110 1.5h-7.5a.75.75 0 010-1.5h7.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Expenses = /*#__PURE__*/forwardRef(IconExpenses);

export default Expenses;
//# sourceMappingURL=Expenses.js.map
